import { defineComponent as u, ref as o, onBeforeUpdate as c, openBlock as v, createElementBlock as f, createElementVNode as l, toDisplayString as i } from "vue";
const d = ["data-message"], m = ["aria-live", "textContent"], p = ["aria-live", "textContent"], B = /* @__PURE__ */ u({
  name: "AriaAnnouncer",
  __name: "AriaAnnouncer",
  props: {
    politeness: {
      type: String,
      required: !1,
      default: "polite",
      validator(e) {
        return ["polite", "assertive", "off"].includes(e);
      }
    },
    message: {
      type: String,
      required: !1,
      default: ""
    }
  },
  setup(e) {
    const a = e, n = o(""), s = o(""), t = o(1), r = () => {
      t.value === 1 && (n.value = a.message, s.value = ""), t.value === 2 && (s.value = a.message, n.value = ""), t.value = t.value === 1 ? 2 : 1;
    };
    return c(() => {
      a.message && r();
    }), (g, x) => (v(), f("div", {
      "data-message": e.message
    }, [l("p", {
      ref: "box1El",
      "aria-live": e.politeness,
      textContent: i(n.value)
    }, null, 8, m), l("p", {
      ref: "box2El",
      "aria-live": e.politeness,
      textContent: i(s.value)
    }, null, 8, p)], 8, d));
  }
});
export {
  B as default
};
